import React, { useEffect,useState } from 'react'

import CssBaseline from '@material-ui/core/CssBaseline'
import EnhancedTable from './EnhancedTable'
import makeData from './tests/makeData'
import EnhancedTableMatiere from './EnhancedTableMatiere'
import axios from 'axios';

const LoadData=(setData,props)=>
{
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getmatieres?id_enseignant='+props.userid)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
       // console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        setData(jsonResponse);
        props.handleDataMatiereEnseignant(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}


const TableMatieres = props => {
  //const isnotenseignant_prop=isnotenseignant;
  console.log("TableMatiere");
  console.log(props.isnotenseignant);
  console.log(props);
  
  const columns = React.useMemo(
    () => [
      {
        Header: 'Nom de la matière',
        accessor: 'matiere',
      },
      {
        Header: 'code',
        accessor: 'code',
      },
      {
        Header: 'Etat',
        accessor: 'status',
      },
     
    ],
    []
  )
  useEffect(() => {
    console.log("mounted");
    console.log(props);
    LoadData(setData,props);
  }, []);
 // const [data, setData] = React.useState(React.useMemo(() => makeData(20), []))
  //const [data, setData] = React.useState(React.useMemo(() => makeData(20), []))
  const [data, setData] = React.useState(React.useMemo(() =>[], []))
  const [skipPageReset, setSkipPageReset] = React.useState(false)
  
  //const [isnotenseignant_prop, setIsNotEnseignant] = React.useState(isnotenseignant)

  // We need to keep the table from resetting the pageIndex when we
  // Update data. So we can keep track of that flag with a ref.

  // When our cell renderer calls updateMyData, we'll use
  // the rowIndex, columnId and new value to update the
  // original data
  const updateMyData = (rowIndex, columnId, value) => {
    // We also turn on the flag to not reset the page
    setSkipPageReset(true);
    LoadData(setData,props);
    return;
    setData(old =>
      old.map((row, index) => {
        if (index === rowIndex) {
          return {
            ...old[rowIndex],
            [columnId]: value,
          }
        }
        return row
      })
    )
  }
  const DeleteData=(stid)=>
{
  
  axios.get('/api/public/delmatieres?id_matiere='+stid, {
    headers: {
      "Content-Type": "application/json"
    },
    responseType: "json"
  })
    .then(response => {
     
      console.log(response.data);
      updateMyData(0,0,-1);
     
    })
    .catch(err => {
      console.log("error", err);
    });
    
  
  /*var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/delmatieres?id_matiere='+stid)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        updateMyData(0,0,0);
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }*/
}
  const userid=props.userid
  return (
    <div>
    {userid!=""?<div id="id_table_Matieres" style={{display:props.isnotenseignant}}> 
    <CssBaseline />
    <EnhancedTableMatiere 
      userid={props.userid}     
      columns={columns}        
      data={data}  
      DeleteData={DeleteData}      
      setData={setData}        
      updateMyData={updateMyData}        
      skipPageReset={skipPageReset} />  
       </div>:<div></div>}
  </div>
  )
}

export default TableMatieres
